"use client";

import { useState } from "react";

import { Details } from "@/components/audioPlayers/audioPlayerDownloadStemSplitGroup/Details";
import { DoneStemSplitGroup } from "@/components/audioPlayers/audioPlayerDownloadStemSplitGroup/DoneStemSplitGroup";
import { FailedStemSplitGroup } from "@/components/audioPlayers/audioPlayerDownloadStemSplitGroup/FailedStemSplitGroup";
import { NotDoneStemSplitGroup } from "@/components/audioPlayers/audioPlayerDownloadStemSplitGroup/NotDoneStemSplitGroup";
import { StemSplitGroupWithAudioNoDates } from "@/types/defs/stemSplit";

export function AudioPlayerDownloadStemSplitGroup({
  stemSplitGroup,
}: {
  stemSplitGroup: StemSplitGroupWithAudioNoDates;
}) {
  const [open, setOpen] = useState(false);

  const failed = stemSplitGroup.failed;

  const StemSplitGroupConfirmedDone = stemSplitGroup.confirmedDone;

  return (
    <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-gray-900/5">
      {failed && <FailedStemSplitGroup stemSplitGroup={stemSplitGroup} />}

      {!failed && StemSplitGroupConfirmedDone && (
        <DoneStemSplitGroup
          stemSplitGroup={stemSplitGroup}
          open={open}
          setOpen={setOpen}
        />
      )}

      {!failed && !StemSplitGroupConfirmedDone && (
        <NotDoneStemSplitGroup stemSplitGroup={stemSplitGroup} />
      )}

      {open && StemSplitGroupConfirmedDone && (
        <Details stemSplitGroup={stemSplitGroup} />
      )}
    </div>
  );
}
